import {Component} from 'react';
import ReactDOM from 'react-dom';

export default class PortalToBody extends Component {
    public render() {
        return ReactDOM.createPortal(
            this.props.children,
            document.body
        );
    }
}
